module.exports = __webpack_public_path__ + "img/payment-in-advance-alternate.c8d102f6.png";